
import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ResourceService } from 'src/app/services/resource/resource.service';

@Component({
  selector: 'app-blog-category',
  templateUrl: './blog-category.component.html',
  styleUrls: ['./blog-category.component.css']
})
export class BlogCategoryComponent implements OnInit {


  Submitted: boolean = false;
  BlogCategoryList:any;

  constructor(private resourceService: ResourceService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

     ClearResource(){
       
     }
  ResourceModel = {
    BlogCategoryID:0,
    BlogCategory:'',
    ShortDescription:'',
    MetaKeywords:'',
    IsPublish: false,   
    ResourceID:0,
  };

  ClearBlog() {
    this.Submitted = false;  
    this.ResourceModel.BlogCategoryID = 0;
    this.ResourceModel.BlogCategory = '';   
    this.ResourceModel.ShortDescription = '';   
    this.ResourceModel.MetaKeywords = '';   
  };

 
  SaveBlogCategory(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.resourceService.SaveBlogCategory(JSON.stringify(this.ResourceModel)).subscribe((data: any) => {
        this.spinnerService.hide();
        if(data.webResponse.Status && this.ResourceModel.BlogCategoryID==0){
          this.ClearBlog();
         }
        if(data.webResponse.Status){
          this.GetAllBlogCategory();
        }
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  SearchModel={
    ResourceType:'0'
  }

  GetAllBlogCategory() {
    this.spinnerService.show();
    this.resourceService.GetAllBlogCategory(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.BlogCategoryList = data.BlogCategoryList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });

  }

  EditBlogCategory(obj) {   
    this.ResourceModel.BlogCategoryID = obj.BlogCategoryID;
    this.ResourceModel.BlogCategory = obj.BlogCategory;
    this.ResourceModel.ShortDescription = obj.ShortDescription;
    this.ResourceModel.MetaKeywords = obj.MetaKeywords;
    this.ResourceModel.IsPublish = obj.IsPublish; 

  };

  ngOnInit() {
   this.GetAllBlogCategory();
  }

  PackageList=[];
  GetAllPackage() {

    this.LookupService.GetLookupsList('PackageForMatrix', '').subscribe((data: any) => {
      this.PackageList = data.LookupItems;
    });
  }

  

}


